module.exports = __webpack_public_path__ + "static/media/bg-vip-2.d6d011c8.png";